import initSentry from '../../../src/common/lib/sentry';

initSentry();
